import { getApiBaseUrl } from '@/config/apiBase'

export type AuthOidcStatus = {
  mode: 'local' | 'dual' | 'oidc'
  localEnabled: boolean
  oidcEnabled: boolean
  idpName: string
}

/** SSO desativado — no-op (evita ruído no console). */
export function ssoLog(_step: string, _detail?: Record<string, unknown>): void {
  /* intentionally empty */
}

export const LOCAL_AUTH_OIDC_STATUS: AuthOidcStatus = {
  mode: 'local',
  localEnabled: true,
  oidcEnabled: false,
  idpName: 'Conecta ID',
}

export async function fetchAuthOidcStatus(): Promise<AuthOidcStatus> {
  return LOCAL_AUTH_OIDC_STATUS
}

/** Redirect full-page para o backend iniciar OIDC (PKCE no servidor). */
export function startConectaIdLogin(): void {
  const base = getApiBaseUrl()
  window.location.assign(`${base}/auth/oidc/login`)
}
